// extracted by mini-css-extract-plugin
export default {"modal":"r8Lqj7OUmYP5ic5dzTdf"};